import { Component, ViewChild } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { MatTableDataSource, MatPaginator, MatSort,DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material';
import { DatePipe } from "@angular/common";
import Swal from "sweetalert2";
import * as moment from 'moment';
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { MessagesTitles, MessagesGeneral, MessagesDates } from '../../../models/messages';

export const MY_FORMATS = { parse: {dateInput: "DD-MM-YYYY"},
  display: {
    dateInput: "DD-MM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY"
  }
};

import { MetaService } from '../../../services/meta/meta.service';

@Component({
  selector: 'app-listado-area',
  templateUrl: './listado-area.component.html',
  styleUrls: ['./listado-area.component.scss'],
  providers: [MessagesTitles,MessagesGeneral,MessagesDates,
    DatePipe,
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0', visibility: 'hidden' })),
      state('expanded', style({ height: '*', visibility: 'visible' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})

export class ListadoAreaComponent   {
  varAbrirArea : boolean = false;
  
  Area : any =[];
  fecha : any = new Date();

  fechaD : any = moment().date(1);
  fechaH : any = moment();
  
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;  
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  pageSizeOptions = [15,20,30,50,100,200];
  loading:boolean;
  displayedColumns: string[] = ['checked','idArea','Nombre','MontoReal','MontoProyectado','MontoDiferido','FechaInicio','FechaFin','Estado',];
  dataSource : any; 
  
  displayedColumnsSecondTable = ['checked','MontoReal', 'MontoProyectado', 'MontoDiferido','FechaInicio','FechaFin'];
  MetaArray : any = [];
  

  constructor(private metaService : MetaService, private datePipe :DatePipe) {this.ListadoMeta();}



  expandCollapse(row, index) {
    row.isExpanded = row.isExpanded === true ? false : true;
    this.MetaArray = JSON.parse(sessionStorage.getItem('lstMeta'));
    const prueba = this.MetaArray.filter(filt => filt.idArea == row.idArea)
    
    this.MetaArray = new MatTableDataSource(prueba);
  }
  
  ListadoArea(){
    this.loading = true;

  
  this.metaService.ObtenerListarArea(this.datePipe.transform(this.fechaD,'yyyy-MM-dd'),this.datePipe.transform(this.fechaH,'yyyy-MM-dd'))                                                  
    .subscribe(
        res => {
      this.Area = res;
      this.dataSource = new MatTableDataSource(this.Area);
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
      this.loading = false;
        } , err =>{
            Swal.fire({
              title: "¡Algo salió mal!",
              text:  err.error['error'],
              type: "warning",
              allowOutsideClick: true
            });        
          this.loading = false;
        }
    )
  }

  ListadoMeta(){
    this.metaService.ObtenerListarMeta().subscribe(res => {
        sessionStorage.setItem('lstMeta',JSON.stringify(res));
        });
  }
  
  agregarArea(){
    this.varAbrirArea = true;
  }

  agregarUsuario(){
    this.varAbrirArea = true;
  }
  
  

  MetCerrarArea(){
    this.varAbrirArea = false;
  }
}
